import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { SignalStore } from '../../../store/app.store';
import { AuthService } from '../../shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileSettingsModalComponent } from '../modals/profile-settings-modal/profile-settings-modal.component';
import { Location } from '@angular/common';
import { OutsideClickDirective } from '../../shared/directives/outside-click.directive';
import { TranslateModule } from '@ngx-translate/core';
import { MatRipple } from '@angular/material/core';
import {MatTooltip} from "@angular/material/tooltip";
import {IconAccountComponent} from "../icons/icon-account/icon-account.component";
import {IconAnswerComponent} from "../icons/icon-answer/icon-answer.component";
import {IconFavoriteComponent} from "../icons/icon-favorite/icon-favorite.component";
import {IconDraftComponent} from "../icons/icon-draft/icon-draft.component";
import {IconLogoutComponent} from "../icons/icon-logout/icon-logout.component";

@Component({
  selector: 'app-account-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    OutsideClickDirective,
    TranslateModule,
    MatRipple,
    MatTooltip,
    IconAccountComponent,
    IconAnswerComponent,
    IconFavoriteComponent,
    IconDraftComponent,
    IconLogoutComponent,
  ],
  templateUrl: './account-menu.component.html',
  styleUrl: './account-menu.component.scss',
})
export class AccountMenuComponent implements OnInit {
  public store = inject(SignalStore);
  private $auth = inject(AuthService);
  private $modal = inject(MatDialog);
  private route = inject(ActivatedRoute);
  private $router = inject(Router);
  private $location = inject(Location);

  user = this.store.getUser();
  isOpen = signal<boolean>(false);

  ngOnInit() {
    if (this.$auth.isAuth()) {
      if (this.route.snapshot.queryParamMap.has('access_token')) {
        this.navigateTo('logout');
        return;
      }
      this.store.loadUser();
    }
  }

  navigateTo(url: string) {
    if (url === 'logout') {
      this.$auth.logOut();
      this.isOpen.set(false);
      return;
    }
    if (url === 'profile') {
      this.$modal
        .open(ProfileSettingsModalComponent, {
          width: '400px',
          panelClass: ['outer-close', 'white', 'btn-back'],
          autoFocus: false,
          disableClose: window.innerWidth >= 768,
        })
        .afterOpened()
        .subscribe(() => {
          this.isOpen.set(false);
          const pathWithHash = this.$location.path() + '#profile';
          this.$location.replaceState(pathWithHash);
        });
      return;
    }
    this.$router.navigate(['/' + url]).then(() => this.isOpen.set(false));
  }

  toggleMenu() {
    this.isOpen.update((value) => !value);
  }

  closeMenu() {
    this.isOpen.set(false);
  }

  accountName = computed(() => {
    if (this.user.name())
      return this.store.getUserName()();
    else if (this.user.email())
      return this.user.email();
    return this.user.phone();
  });
}
